import { Validators } from '@angular/forms';
import { IColumnConfigTableResponsive } from 'src/app/domain/IColumnConfigTableResponsive';
import { FieldTypeEnum } from 'src/app/domain/registration/enums/field-type.enum';
import { SystemTypeEnum, SystemTypeIdEnum } from 'src/app/domain/registration/enums/system-type.enum';
import { TableResponsiveTypeColumnEnum } from 'src/app/domain/registration/enums/table-responsive-type-column.enum';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';
import { CustomerIndexMultiSelectComponent } from '../customers/crud-index/crud-index-multiselect.component';
import { SystemIndexSelectComponent } from '../systems/crud-index/crud-index-select.component';
import { MethodPaymentAccessTypeEnum } from 'src/app/domain/registration/enums/method-payment-acess-type.enum';
export const RELATIVE_URL = 'customer-acess';

export const COLUMNS_TO_SHOW_WEB = [
  'select',
  'image',
  'customers',
  'email',
  'password', 
  'system',
  'createdAt', 
  'actions',
];

export const COLUMNS_TO_SHOW_MOBILE = COLUMNS_TO_SHOW_WEB;

export const TABLE_CONFIG_COLUMNS: IColumnConfigTableResponsive[] = [

  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'customers',
    display: 'CLIENTE',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'email',
    display: 'E-MAIL',
    class: 'soluction-name-column text-center', 
    headerClass: 'soluction-name-header-column text-center', 
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'type',
    display: 'TIPO',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column text-center`,
  },
  {
    field_type: FieldTypeEnum.IMAGE,
    link_show: true,
    property: 'image',
    display: '  ',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} image-size responsive-column text-center`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'system',
    display: 'SISTEMA',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column text-center`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'fileType', 
    display: 'TIPO DE ACESSO', 
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column text-center`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'password', 
    display: 'SENHA', 
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column text-center`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'createdAt',
    display: 'CRIADO EM',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column text-center`,
  },
];

export const CES_CONFIG_FIELDS = [
  {
    type: TypeComponentFieldEnum.HIDDEN,
    name: 'id',
  },
 
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'E-MAIL',
    name: 'email',
    validators: [ ],
  },
    {
    type: TypeComponentFieldEnum.SELECT_CRUD,
    label: 'CLIENTE',
    component: CustomerIndexMultiSelectComponent,
    name: 'customers',
    value: 'name',
    defaultValue: ' ',
    options: [Object.values([])],
    placeholder: 'Selecione um Cliente',
    validation: [],
  },
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'TIPO',
    name: 'type',
    options: Object.values(SystemTypeEnum),
    placeholder: 'Selecione uma opção',
    validators: [Validators.required],
  },
  {
    type: TypeComponentFieldEnum.SELECT_CRUD,
    label: 'Sistema',
    component: SystemIndexSelectComponent,
    componentData: {
      params: { type: SystemTypeIdEnum[SystemTypeEnum.SYSTEM] },
    },
    name: 'system',
    value: 'name',
    defaultValue: ' ',
    options: [Object.values([])],
    placeholder: 'Selecione uma opção',
    validation: [Validators.required],
  },
  // {
  //   type: TypeComponentFieldEnum.SELECT,
  //   label: 'TIPO DE ACESSO', 
  //   name: 'fileType',
  //   options: Object.values(FileTypeEnum),
  //   placeholder: 'Selecione uma opção',
  //   validators: [Validators.required],
  // },

// adicionar campo de cliente no lugar de tipo de acesso
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'SENHA', 
    name: 'password', 
    validators: [Validators.required],
  },
  {
    type: TypeComponentFieldEnum.INPUT_FILE,
    label: 'ANEXAR ARQUIVO DE SENHAS', 
    name: 'fileAttachment', 
    validators: [Validators.required],
  },
  {
    type: TypeComponentFieldEnum.INPUT_TEXT_AREA,
    label: 'DETALHES DO ACESSO',
    name: 'acessDescription',
    validators: [Validators.required],
  },
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'MÉTODO DE PAGAMENTO',
    name: 'paymentMethod',
    options: Object.values(MethodPaymentAccessTypeEnum),
    placeholder: 'Selecione um método',
    validators: [],
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'CHAVE PIX',
    name: 'pixKey',
    validators: [],
  },
  {
    labelSave: 'Salvar',
    labelCancel: 'Cancelar',
    name: 'cancelSave',
    type: TypeComponentFieldEnum.CANCEL_SAVE,
  },
];
